"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
var Utilities_1 = require("../../Utilities");
var Dialog_base_1 = require("./Dialog.base");
var Dialog_styles_1 = require("./Dialog.styles");
exports.Dialog = (0, Utilities_1.styled)(Dialog_base_1.DialogBase, Dialog_styles_1.getStyles, undefined, { scope: 'Dialog' });
exports.Dialog.displayName = 'Dialog';
//# sourceMappingURL=Dialog.js.map